import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zh from "./locales/zh.json";

// constants
export const EN = "en";
export const ZH = "zh";
export const LOCAL_STORAGE_LANG_KEY = "language";

const resources = { en, zh };

const params = new URLSearchParams(window.location.search);
const langParam = params.get("lang");

if (langParam && [EN, ZH].includes(langParam))
  localStorage.setItem(LOCAL_STORAGE_LANG_KEY, langParam);

const lng = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);

i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: EN,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
